import { RouteConfigComponentProps } from "react-router-config";
import { useCheckAuthority } from "../../shared/CustomHooks";

const Perfil = (routeProps: RouteConfigComponentProps): JSX.Element => {
  return useCheckAuthority(routeProps) || <div>Perfil Form</div>;
};

export default Perfil;
